/************
 * Developed by : Shiva Software Solutions
 * Date : 12-08-2025
 * Descriptions : Call api response using reducers
 ************/
import {
  RESET_STATE,
  DIGIOPD_AUDIO_LIST
} from '../../shared/constants/ActionTypes';

const initialState = {
  digiaudioList: [],
};

const audioDigiReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_STATE:
      return {...initialState}; // Reset the state to the initial state
    //Assign dischargelist
    case DIGIOPD_AUDIO_LIST:
      return {
        ...state,
        digiaudioList: action.payload,
      };

    default:
      return state;
  }
};
export default audioDigiReducer;
